import { compact } from "lodash";
import { useEffect, useState } from "react";

import Layout from "@components/layout/layout";
import { ToggleButtonGroupType } from "@components/toggle-button-group/toggle-button-group";

import ProfileSidebarDetails from "./profile-sidebar-details";
import SidebarPrivateNotes from "./sidebar-private-notes";

enum ProfileSidebarTab {
  myNotes = "My Notes",
  details = "Details",
}

const ProfilePageSidebar = ({
  profileId,
  showPrivateNotes,
  subjectName,
}: {
  profileId: number;
  showPrivateNotes: boolean;
  subjectName?: string;
}) => {
  const [activeTab, setActiveTab] = useState<ProfileSidebarTab>(
    showPrivateNotes ? ProfileSidebarTab.myNotes : ProfileSidebarTab.details,
  );

  const handleChangeTab = (
    option: ToggleButtonGroupType<ProfileSidebarTab>,
  ) => {
    if (option.value) setActiveTab(option.value);
  };

  const tabs = compact([
    showPrivateNotes && {
      value: ProfileSidebarTab.myNotes,
      title: ProfileSidebarTab.myNotes,
      active: activeTab === ProfileSidebarTab.myNotes,
    },
    {
      value: ProfileSidebarTab.details,
      title: ProfileSidebarTab.details,
      active: activeTab === ProfileSidebarTab.details,
    },
  ]);

  useEffect(() => {
    const activeTabExists = tabs.find((tab) => tab.active);
    if (!activeTabExists && tabs.length > 0) {
      setActiveTab(tabs[0].value);
    }
  }, [tabs]);

  return (
    <Layout.Sidebar<ProfileSidebarTab>
      tabs={tabs}
      onChangeTab={handleChangeTab}
      sidebarExpandedUiPreferenceKey="profileSidebarExpanded"
    >
      {activeTab === ProfileSidebarTab.myNotes && showPrivateNotes && (
        <SidebarPrivateNotes profileId={profileId} subjectName={subjectName} />
      )}
      {activeTab === ProfileSidebarTab.details && (
        <ProfileSidebarDetails profileId={profileId} />
      )}
    </Layout.Sidebar>
  );
};

export default ProfilePageSidebar;
